import React from "react";
import {Card, Grid, IconButton, List, ListItem, ListItemText, Toolbar, Typography} from "@material-ui/core";
import {ArrowBack} from "@material-ui/icons";
import {useStyles} from "./containers/taxonomy";
import {pocPrimary, useGlobalStyles} from "../../utils/styles";
import {Link} from "react-router-dom";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

export default function Settings(props) {
    const classes = useStyles();
    const globalClasses = useGlobalStyles();

    return (
        <Grid container className={classes.root}
              style={{gap: "24px", padding: "24px 14px 24px 14px", position: "relative"}}>
            <Grid container justify={"space-between"} direction={"row"}>
                <Grid item container xs={6} justify={"flex-start"} alignItems={"center"} style={{gap: "12px"}}>
                    <IconButton className={globalClasses.iconButton}
                                style={{height: "36px", width: "36px"}}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (props.location.key === undefined)
                                        props.history.push("/productonboardingcenter/catalog");
                                    else
                                        props.history.goBack();
                                }}>
                        <ArrowBack style={{height: "18px", width: "18px"}}/>
                    </IconButton>

                    <Typography className={classes.header}>
                        Settings
                    </Typography>
                </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
                <Card>
                    <Toolbar className='lbtoolbar'
                             style={{background: pocPrimary}}
                    >
                        Product Onboarding Settings
                    </Toolbar>
                    <List style={{padding: 0}}>
                        <ListItem button component={Link} to='/productonboardingcenter/settings/taxonomy'>
                            <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="Taxonomy"
                                          secondary='View and manage your categories, attributes and attribute sets.'/>
                            <ArrowForwardIosIcon color={pocPrimary}/>
                        </ListItem>
                        <ListItem button component={Link} to={'/productonboardingcenter/settings/general'}>
                            <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="General"
                                          secondary='Configure settings around how you store and receive data.'/>
                            <ArrowForwardIosIcon color={pocPrimary}/>
                        </ListItem>
                        <ListItem button component={Link} to={'/productonboardingcenter/settings/connector'}>
                            <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="Connector Configurations"
                                          secondary='Configure settings around how you send data to each connector.'/>
                            <ArrowForwardIosIcon color={pocPrimary}/>
                        </ListItem>
                        <ListItem button component={Link} to={'/productonboardingcenter/settings/auto-approve'}>
                            <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}}
                                          primary="Auto Approve Attribute Changes"
                                          secondary='Approve any updates sent by your suppliers for the specified attributes.'/>
                            <ArrowForwardIosIcon color={pocPrimary}/>
                        </ListItem>
                        <ListItem button component={Link} to={'/productonboardingcenter/settings/auto-ignore'}>
                            <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="Auto Ignore Attribute Changes"
                                          secondary='Automatically ignore any updates sent by your suppliers for the specified attributes.'/>
                            <ArrowForwardIosIcon color={pocPrimary}/>
                        </ListItem>
                    </List>
                </Card>
            </Grid>
        </Grid>
    )
}
